// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"3f061cc8","212":"aada4708","453":"730dc28c"}[chunkId] + ".chunk.js";
};